/**
 * HumanScaled Logo — Solid circle with cutout "H"
 * Works on dark and light backgrounds.
 */
export const HSLogo = ({ size = 32, color = '#10b981', className = '' }) => {
  const r = size / 2;
  const barW = size * 0.18;
  const gap = size * 0.22;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className={className} aria-label="HumanScaled logo">
      <circle cx={r} cy={r} r={r} fill={color} />
      {/* Left vertical of H */}
      <rect x={r - gap - barW} y={size * 0.22} width={barW} height={size * 0.56} rx={1} fill="#050505" />
      {/* Right vertical of H */}
      <rect x={r + gap} y={size * 0.22} width={barW} height={size * 0.56} rx={1} fill="#050505" />
      {/* Crossbar of H */}
      <rect x={r - gap - barW} y={r - barW * 0.45} width={gap * 2 + barW * 2} height={barW * 0.9} rx={1} fill="#050505" />
    </svg>
  );
};

export default HSLogo;
